import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsersClass } from '@fortawesome/pro-light-svg-icons/faUsersClass';

import LinkButton from '../common/Buttons/LinkButton';
import LoginSwitchContext from './LoginSwitchContext';
import AccountsArea from './AccountsArea';

class SwitchContextArea extends Component {
  state = {
    colors: [],
    tryToLogin: -1,
  };

  componentDidMount() {
    const { accountList } = this.props;
    const colors = [];
    accountList.forEach(() => {
      colors.push(this.generateColor());
    });
    this.setState({ colors });
  }

  generateColor = () => {
    return `#${Math.random().toString(16).substr(-6)}`;
  };

  handleLogin = (e, account) => {
    this.setState({ tryToLogin: account });
  };

  goBack = () => {
    this.setState({ tryToLogin: -1 });
  };

  render() {
    const { accountList, mfaEnabled, onCancel, t } = this.props;
    const { colors, tryToLogin } = this.state;

    return (
      <div className="settings-list accounts-list editing">
        {tryToLogin !== -1 && <LoginSwitchContext t={t} account={accountList[tryToLogin]} mfaEnabled={mfaEnabled} onCancel={this.goBack} color={colors[tryToLogin]} />}
        {tryToLogin === -1 && (
          <div className="account-list-area">
            <div className="account-list-header">
              <h1>
                <span>
                  <FontAwesomeIcon icon={faUsersClass} />
                  &nbsp; {t('labelSwitchAccount')}
                </span>
                <LinkButton className="edit-button" onClick={onCancel}>
                  {t('labelGoBack')}
                </LinkButton>
              </h1>
            </div>

            <AccountsArea handleLogin={this.handleLogin} accountList={accountList} t={t} colors={colors} />
          </div>
        )}
      </div>
    );
  }
}

export default SwitchContextArea;
